import { colors } from 'app/theme/colors';

export const labelStyle: any = {
  textTransform: 'none',
  fontSize: '1.2em',
  fontWeight: 500,
  color: colors.mineShaft,
};
